import { DesignStudioSmsEditorRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/sms/$id')({
  component: DesignStudioSmsEditorRoute,
});
